import React from "react";

const NoPage = () => {
  return (
    <h1 style={{ marginTop: "145px" }}>404 Error Page not found, sorry</h1>
  );
};

export default NoPage;
